<div class="app" dir="ltr">
  <div class="app-body" style="align-items:center;flex-direction:column">
    <div class="navbar-brand-logo" style="width:80vw;height:60vh;background-size:100%;display:flex"></div>
    <div id="logging-in" style="display:flex;flex-direction:column">

      @if (auth.isUserLoggedIn()) {
      <button type="button" kendoButton [themeColor]="'success'" [size]="'large'" (click)="logout()">Logout of PLEX</button>
      <button type="button" kendoButton [themeColor]="'primary'" style="margin-top:2em;" [size]="'large'" (click)="goHome()">Projects Home</button>
      } @else {
      <button type="button" kendoButton [themeColor]="'success'" [size]="'large'" (click)="login()">Login to PLEX</button>
      <h2>Please Login to use PLEX...</h2>
      }
    </div>
  </div>
</div>